import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles((theme) => {
  return {
    formBox: {
      backgroundColor: 'rgba(236, 236, 236, 0.62)',
    },
    formContent: {
      width: '100%',
      padding: '88px',
      [theme.breakpoints.down('md')]: {
        padding: '40px 24px',
      },
    },
    inputNotchedOutline: {
      borderColor: '#CFCFCF !important',
    },
    input: {
      color: '#000',
      backgroundColor: '#fff',
      height: '50px',
    },
    textArea: {
      color: '#000',
      backgroundColor: '#fff',
    },
  }
})
